














































import DropAreaMulti from "@/components/files/DropAreaMulti.vue";
import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import { CurrencyEnum } from "@/lib/enum/currency.enum";
import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { getAutocompleteFilter } from "@/lib/utility/filter";
import { handleError } from "@/lib/utility/handleError";
import { $t } from "@/lib/utility/t";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { IClearance } from "@/models/clearance.entity";
import { RepairEstimate } from "@/models/repair-estimate.entity";
import { WorkshopContractRate } from "@/models/workshop-contract-rate.entity";
import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";
import LineItemsForm from "./LineItemsForm.vue";

@Component({
  components: {
    LineItemsForm,
    ConfirmActionDialog,
    DropAreaMulti
  },
  filters: { simpleDoubleDigitDate }
})
export default class RepairEstimateResponseCostExtensionDialog extends mixins(PermissionMixin, RulesMixin) {
  readonly simpleDoubleDigitDate = simpleDoubleDigitDate;
  readonly getAutocompleteFilter = getAutocompleteFilter;
  readonly CurrencyEnum = CurrencyEnum;
  readonly RequestStatusEnum = RequestStatusEnum;

  @Prop()
  clearance!: IClearance;

  @Prop()
  token!: string;

  @Prop({ default: false })
  isDialogActive!: boolean;

  loadingRespondReject = false;
  loadingRequestMoreData = false;
  isRejectDialogActive = false;
  isRequestMoreDialogActive = false;
  rejectReason = "";
  requestMoreDataReason = "";
  valueCopy = new RepairEstimate({ partnerId: this.clearance.partnerId }).setDefaultLineItems();
  loading = false;
  isValid = false;
  file: File | null = null;
  reason = "";

  get leftText(): string {
    return $t("close");
  }

  get rightText(): string {
    return $t("repairEstimate.response.confirmOffer");
  }

  get files(): File[] {
    if (this.file) {
      return [this.file];
    }
    return [];
  }

  set files(files: File[]) {
    if (files.length > 0) {
      this.file = files[0];
    } else {
      this.file = null;
    }
  }

  get dialogModel() {
    return this.isDialogActive;
  }

  set dialogModel(v: boolean) {
    if (!v) {
      this.$emit("close");
    }
    this.$emit("update:isDialogActive", v);
  }

  open() {
    this.valueCopy = new RepairEstimate({ partnerId: this.clearance.partnerId }).setDefaultLineItems();

    if (!this.valueCopy.workshopRate) {
      this.valueCopy.workshopRate = new WorkshopContractRate();
    }

    this.isDialogActive = true;
  }

  close() {
    this.isDialogActive = false;
    this.isRejectDialogActive = false;
    this.isRequestMoreDialogActive = false;
  }

  async rightClick() {
    await this.confirmRepairEstimateResponse();
  }

  leftClick() {
    this.close();
  }

  async confirmRepairEstimateResponse() {
    if (!this.file || !this.valueCopy.number || !this.valueCopy.totalNet) {
      this.$toast.error(this.$t("repairEstimate.response.missingFields"));
      return;
    }

    this.loading = true;
    try {
      await this.clearance.requestCostExtension(this.token, {
        lineItems: this.valueCopy.lineItems.map(li => li.dto),
        number: this.valueCopy.number,
        file: this.file,
        currency: this.valueCopy.currency as CurrencyEnum
      });

      this.$toast.success(this.$t("repairEstimate.response.success"));
    } catch (error) {
      handleError(error);
    } finally {
      this.loading = false;
      this.close();
    }
  }

  @Watch("file", { deep: true })
  onFileChange(file: File) {
    if (file && file.name.endsWith(".pdf")) {
      if (!this.valueCopy.number) {
        this.valueCopy.number = file.name
          .substring(0, file.name.length - 4)
          .replace(/\s+/g, "")
          .replace(/[^\w\d-]/g, "");
      }

      this.$nextTick(() => {
        (this.$refs.startField as HTMLInputElement)?.focus();
      });
    }
  }
}
